export enum Constants {
  AsuDomain = '@asu.edu',
  CheckboxCheckedValue = 'Yes',
  CheckboxUncheckedValue = 'No',
  // eslint-disable-next-line no-template-curly-in-string
  SenderEmailDefaultValue = '${sender.email}'
}